// chakra imports
import { Box, ChakraProvider, Portal } from '@chakra-ui/react';
import Footer from 'components/Footer/Footer.js';
// React-redux
import { connect } from 'react-redux';
import { loadUser } from 'actions/auth';
import setAuthToken from 'utils/setAuthToken';
// core components
import AuthNavbar from 'components/Navbars/AuthNavbar.js';
import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from 'routes.js';
import theme from 'theme/themeAuth.js';

import PropTypes from 'prop-types';

function Pages(props) {
	const { ...rest } = props;
	// ref for the wrapper div
	const wrapper = React.createRef();
	React.useEffect(() => {
		document.body.style.overflow = 'unset';
		// Specify how to clean up after this effect:
		return function cleanup() {};
	});

	React.useEffect(() => {
		if (sessionStorage.token) {
			// Set auth-x-token as default header in axios call
			setAuthToken(sessionStorage.token);
		}
		loadUser();

		// store.dispatch(loadUser());
		// Specify how to clean up after this effect:
		return function cleanup() {};
	}, []);
	const getActiveRoute = (routes) => {
		let activeRoute = 'Default Brand Text';
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse) {
				let collapseActiveRoute = getActiveRoute(routes[i].views);
				if (collapseActiveRoute !== activeRoute) {
					return collapseActiveRoute;
				}
			} else if (routes[i].category) {
				let categoryActiveRoute = getActiveRoute(routes[i].views);
				if (categoryActiveRoute !== activeRoute) {
					return categoryActiveRoute;
				}
			} else {
				if (
					window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
				) {
					return routes[i].name;
				}
			}
		}
		return activeRoute;
	};
	const getActiveNavbar = (routes) => {
		let activeNavbar = false;
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].category) {
				let categoryActiveNavbar = getActiveNavbar(routes[i].views);
				if (categoryActiveNavbar !== activeNavbar) {
					return categoryActiveNavbar;
				}
			} else {
				if (
					window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
				) {
					if (routes[i].secondaryNavbar) {
						return routes[i].secondaryNavbar;
					}
				}
			}
		}
		return activeNavbar;
	};
	const getRoutes = (routes) => {
		return routes.map((prop, key) => {
			if (prop.collapse) {
				return getRoutes(prop.views);
			}
			if (prop.category === 'account') {
				return getRoutes(prop.views);
			}
			if (prop.layout === '/auth') {
				return (
					<Route
						path={prop.layout + prop.path}
						component={prop.component}
						key={key}
					/>
				);
			} else {
				return null;
			}
		});
	};
	const navRef = React.useRef();
	document.documentElement.dir = 'ltr';
	return (
		<ChakraProvider theme={theme} resetCss={false} w="100%">
			<Box ref={navRef} w="100%">
				<Portal containerRef={navRef}>
					<AuthNavbar
						secondary={getActiveNavbar(routes)}
						logoText="NiFTy<>$Wap"
					/>
				</Portal>
				<Box w="100%">
					<Box ref={wrapper} w="100%">
						<Switch>
							{getRoutes(routes)}
							<Redirect from="/auth" to="/auth/signin" />
						</Switch>
					</Box>
				</Box>
			</Box>
		</ChakraProvider>
	);
}

Pages.propTypes = {
	auth: PropTypes.object.isRequired,
	loadUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
	// Will now have props.alerts available to comp
	auth: state.auth,
});

export default connect(mapStateToProps, { loadUser })(Pages);
